import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild
} from '@angular/core';
import {
  PercPipe,
  NumPipe,
  NumberFormatStyle
} from '../../../../../pipes/perc.pipe';
import { DataTableHeader } from '../../../../data-table/DataTableHeader';
import { RoundSigPipe } from '../../../../../pipes/roundsig.pipe';
import { User } from '../../../../../models/User';
import { ParamValueModel } from '../../../../../models/ParamValueModel';
import { CustomItemContext } from 'app/components/data-table/data-table.component';
import { PieChartData } from '../../../charts/models/PieChartData';

@Component({
  selector: 'domain-sov',
  templateUrl: './domain-sov.html',
  styleUrls: ['./domain-sov.css']
})
export class DomainSov implements OnInit, OnChanges {
  @Input() domain;
  @Input() data: any;
  @Input() month;
  @Input() appName;
  @Input() os;
  @Input() isFollowing: boolean;
  @Output() toAppDiscovery: EventEmitter<ParamValueModel> =
    new EventEmitter<ParamValueModel>();
  @Output() anchorClick: EventEmitter<any> = new EventEmitter<any>();

  showMore = false;
  headers = new Array<DataTableHeader>();
  sellers = [];
  chartSellers = [];
  directSellers = [];
  resellers = [];
  percPipe = new PercPipe();
  showMoreLimit = 5;
  directSellersChartData: Array<PieChartData> = [];
  resellersChartData: Array<PieChartData> = [];

  @ViewChild('sellerNameTemplate')
  sellerNameTemplate: TemplateRef<CustomItemContext>;
  @ViewChild('priceBidLowTemplate')
  priceBidLowTemplate: TemplateRef<CustomItemContext>;

  get isFreemium(): boolean {
    return this.user.isFreemium();
  }

  constructor(private user: User) {}

  ngOnInit() {
    this.prepareData();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.prepareData();
  }

  prepareData() {
    this.sellers = JSON.parse(
      JSON.stringify(this.data['sellersShareDistribution']['sellers'])
    );
    this.chartSellers = [];
    this.headers = [];
    this.headers.push({
      class: 'col',
      text: 'SSP/Exchange',
      key: 'sellerName',
      tooltipkey: 'app-seller-name'
    });
    if (this.sellers[0] && this.sellers[0]['paymentType']) {
      this.headers.push({
        class: 'col text-left',
        text: 'PAYMENTS TYPE',
        key: 'paymentType',
        tooltipkey: 'app-payment-type'
      });
    }
    this.headers.push({
      class: 'col',
      text: 'PROGRAMMATIC AVAILS',
      key: 'totalTrafficRatio',
      tooltipkey: 'app-seller-inventory',
      lockedInFreemium: true,
      format: 'percent'
    });
    this.headers.push({
      class: 'col',
      text: 'EST. IVT %',
      key: 'givtSivtRate',
      tooltipkey: 'app-seller-nht',
      format: 'percent',
      lock: () => this.isFreemium && !this.isFollowing
    });
    this.headers.push({
      class: 'col',
      text: 'EST. BID RANGES',
      key: 'priceBidLow',
      lockedInFreemium: true,
      tooltipkey: ''
    });
    this.headers.push({
      class: 'col',
      text: 'EST. VIEWABILITY %',
      key: 'viewability',
      tooltipkey: 'app-seller-viewability',
      format: 'percent'
    });
    this.sellers.sort((seller1, seller2) => {
      if (seller1['paymentType'] === seller2['paymentType']) {
        return 0;
      } else if (seller1['paymentType'] === 'N/A') {
        return 1;
      } else if (seller2['paymentType'] === 'N/A') {
        return -1;
      } else if (seller1['paymentType'] > seller2['paymentType']) {
        return 1;
      } else if (seller1['paymentType'] < seller2['paymentType']) {
        return -1;
      }
    });

    for (const seller of this.sellers) {
      this.chartSellers.push(seller);
      // Modify seller name HTML for to be displayed
      const sellerName = seller['sellerName'];
      const sellerId = seller['sellerId'];
      seller.sellerNameTemplate = this.sellerNameTemplate;
      seller.priceBidLowTemplate = this.priceBidLowTemplate;

      if (seller['paymentType'] === 'N/A') {
        seller['paymentType'] = 'Unauthorized';
      }
    }

    const directSellers = this.chartSellers.filter(
      seller =>
        seller['paymentType'] === 'Direct' && seller['totalTrafficRatio'] > 0
    );
    const resellers = this.chartSellers.filter(
      seller =>
        seller['paymentType'] === 'Reseller' && seller['totalTrafficRatio'] > 0
    );
    this.directSellers = directSellers;
    if (this.directSellers.length > 5) {
      this.showMoreLimit = this.directSellers.length;
    } else if (this.resellers.length > 5) {
      this.showMoreLimit = this.resellers.length;
    }

    this.resellers = resellers;

    this.directSellersChartData = this.directSellers.map(item => {
      return {
        title: item?.sellerName,
        value: item?.totalTrafficRatio,
        category: item?.sellerName
      };
    });

    this.resellersChartData = this.resellers.map(item => {
      return {
        title: item?.sellerName,
        value: item?.totalTrafficRatio,
        category: item?.sellerName
      };
    });
  }

  goTo(paramValue: ParamValueModel) {
    paramValue.param = 'trustedSellerName';
    this.toAppDiscovery.emit(paramValue);
  }
}
